"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChapterDetailsLayout = exports.ChapterDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var entity_value_1 = require("./entity-value");
var link_1 = require("../elements/link");
var entity_link_value_1 = require("./entity-link-value");
var entity_list_1 = require("./entity-list");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var entity_section_1 = require("./entity-section");
var entity_grid_1 = require("./entity-grid");
var use_lang_1 = require("../../hooks/use-lang");
var entity_link_1 = require("./entity-link");
var lodash_1 = require("lodash");
var entity_linked_items_grid_1 = require("./entity-linked-items-grid");
var sdg_value_1 = require("./sdg-value");
var file_asset_value_1 = require("./file-asset-value");
var use_entities_1 = require("../../hooks/use-entities");
var entity_role_value_1 = require("./entity-role-value");
exports.ChapterDetailsLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ActivitiesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ActivitiesGridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EntityLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AfterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ColumnsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var LinkedItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EntityRoleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ResourcesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    padding-top: 0;\n  "], ["\n    padding-top: 0;\n  "])))
});
var RolesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    padding-top: 0;\n  "], ["\n    padding-top: 0;\n  "])))
});
var ChildrenStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    padding-top: 0;\n  "], ["\n    padding-top: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  LinkedItems: (0, styled_components_1.default)(entity_linked_items_grid_1.EntityLinkedItemsGrid)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), LinkedItemsStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Roles: (0, styled_components_1.default)(grid_1.Grid)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), RolesStyles),
  Resources: (0, styled_components_1.default)(grid_1.Grid)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ResourcesStyles),
  Children: (0, styled_components_1.default)(grid_1.Grid)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), ChildrenStyles),
  EntityRole: (0, styled_components_1.default)(entity_role_value_1.EntityRoleValue)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), EntityRoleStyles),
  Activities: (0, styled_components_1.default)(entity_section_1.EntitySection)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), ActivitiesStyles),
  ActivitiesGrid: (0, styled_components_1.default)(entity_grid_1.EntityGrid)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), ActivitiesGridStyles),
  EntityLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), EntityLinkStyles)
};
var ChapterDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var t = (0, use_lang_1.useLang)();
  var entities = (0, use_entities_1.useEntities)();
  var name = entity.name,
    slug = entity.slug,
    _a = entity.directors,
    directors = _a === void 0 ? [] : _a,
    _b = entity.roles,
    roles = _b === void 0 ? [] : _b,
    _c = entity.organisationRoles,
    organisationRoles = _c === void 0 ? [] : _c,
    _d = entity.challenges,
    challenges = _d === void 0 ? [] : _d,
    _e = entity.sdgs,
    sdgs = _e === void 0 ? [] : _e,
    _f = entity.countries,
    countries = _f === void 0 ? [] : _f,
    _g = entity.files,
    files = _g === void 0 ? [] : _g,
    _h = entity.locations,
    locations = _h === void 0 ? [] : _h,
    _j = entity.feedEntries,
    feedEntries = _j === void 0 ? [] : _j,
    _k = entity.documents,
    documents = _k === void 0 ? [] : _k,
    _l = entity.links,
    links = _l === void 0 ? [] : _l,
    _m = entity.impactStories,
    impactStories = _m === void 0 ? [] : _m,
    _o = entity.children,
    children = _o === void 0 ? [] : _o;
  var allRoles = __spreadArray(__spreadArray([], __read(roles), false), __read(organisationRoles), false);
  var description = entity.description;
  var hasDescription = (0, lodash_1.trim)(description && description.text);
  var hasChildren = !!children.length;
  var hasRoles = !!allRoles.length;
  var hasSdgs = !!sdgs.length;
  var hasChallenges = !!challenges.length;
  var hasCountries = !!countries.length;
  var hasLocations = !!locations.length;
  var contact = directors && !!directors.length && directors[0];
  var hasDirectors = !!directors.length;
  var hasResources = !!documents.length || !!links.length || !!impactStories.length || !!feedEntries.length;
  var hasAside = asideHeader || asideFooter || hasSdgs || hasChallenges || hasDirectors || hasCountries || hasLocations;
  var mainGridColumns = hasAside ? 2 : 3;
  var mainGridSpacing = hasAside ? 3 : 4;
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    asideRatio: 2 / 7,
    main: react_1.default.createElement(My.Main, null, mainHeader, hasDescription && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Description, {
      title: 'Overview:',
      entity: description
    })), hasChildren && react_1.default.createElement(My.Section, {
      title: "Sub-Chapters:"
    }, react_1.default.createElement(My.Children, {
      columns: mainGridColumns,
      spacing: mainGridSpacing,
      items: children.map(function (chapter) {
        return react_1.default.createElement(My.LinkValue, {
          key: chapter.id,
          entity: chapter
        });
      })
    })), react_1.default.createElement(My.ListSection, {
      variant: 'large',
      rowComponent: file_asset_value_1.FileAssetValue,
      showDividers: true,
      title: "Related Files:",
      items: files,
      maxItems: 3
    }), hasResources && react_1.default.createElement(My.Section, {
      title: "Resources:"
    }, react_1.default.createElement(My.Resources, {
      columns: mainGridColumns,
      spacing: mainGridSpacing,
      items: (0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray([], __read((documents || []).map(function (document) {
        return react_1.default.createElement(My.LinkValue, {
          entity: document,
          key: document.id
        });
      })), false), __read((impactStories || []).map(function (impactStory) {
        return react_1.default.createElement(My.LinkValue, {
          entity: impactStory,
          key: impactStory.id
        });
      })), false), __read((feedEntries || []).map(function (feedEntry) {
        return react_1.default.createElement(My.LinkValue, {
          entity: feedEntry,
          key: feedEntry.id
        });
      })), false))
    })), hasRoles && entities.ChapterRole && entities.OrganisationChapterRole && react_1.default.createElement(My.Section, {
      title: "".concat(entities.ChapterRole.pluralLabel, ":")
    }, react_1.default.createElement(My.Roles, {
      columns: mainGridColumns,
      spacing: mainGridSpacing,
      items: allRoles.map(function (role) {
        return react_1.default.createElement(My.EntityRole, {
          key: role.id,
          entity: role
        });
      })
    })), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, react_1.default.createElement(My.ListSection, {
      useLinks: true,
      maxItems: 3,
      title: "Directors:",
      items: directors
    }), react_1.default.createElement(My.ListSection, {
      useLinks: true,
      maxItems: 3,
      items: countries
    }), react_1.default.createElement(My.ListSection, {
      useLinks: true,
      maxItems: 3,
      items: locations
    }), react_1.default.createElement(My.ListSection, {
      useLinks: true,
      maxItems: 3,
      items: challenges
    }), react_1.default.createElement(My.ListSection, {
      useLinks: true,
      maxItems: 3,
      orderBy: "number",
      rowComponent: sdg_value_1.SdgValue,
      items: sdgs
    }), asideFooter)
  }));
};
exports.ChapterDetailsLayout = ChapterDetailsLayout;
exports.ChapterDetailsLayout.defaultProps = exports.ChapterDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44;